import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import FullNameInput from "../../../FullName/FullName"
import DateField from "../../../DateField/DateField"
import moment from "moment"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {IdDocumentFormValues} from "./types"
import {birthDateValidation, fullNameValidation, ssnValidation} from "./validationSchemas"

interface IdDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: IdDocumentFormValues
	onSubmit: (values: IdDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	fullName: fullNameValidation,
	dateOfBirth: birthDateValidation,
	ssn: ssnValidation,
})

export const IdDocumentForm = ({documentType, initialValues, onSubmit, formId}: IdDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Name</div>
					<div className="form-row two">
						<FullNameInput fullName={values.fullName} handleChange={handleChange} handleBlur={handleBlur} />
					</div>

					<div className="key-value-card-container-key">Birth Date</div>
					<DateField
						name="dateOfBirth"
						label=""
						value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">SSN</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter SSN"
						name="ssn"
						value={values.ssn}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</form>
			)}
		</Formik>
	)
}
